import initObjectReturn from './object-return';
import initCameraOrbitToggle from './camera-orbit-toggle';
import AutoSpin from './autospin';
import ScaleLimits from './scale-limits';
import selectObject from './select-object';
import PassByRaycaster from '../passby-raycaster';
import getObjectDefaultRotation from '../get-default-rotation';

function init(controls, orbitControls, LimitsCtl, camera, passByRaycasterLoader, disableFlag) {
    if (!window.location.pathname.match(/\/edit_hierarchy_translation\//))

    if (!Q3.isAssetMode) {
        initObjectReturn(controls);
    }

    if (Q3.editMode) {
        initCameraOrbitToggle(orbitControls, controls, LimitsCtl);
    }

    const raycaster = new PassByRaycaster(camera, 0.1, passByRaycasterLoader);
    controls.setObjectSelector(selectObject.bind(this, raycaster));
    controls.setDefaultRotationGetter(object => getObjectDefaultRotation(object.uuid));

    let autoSpin = new AutoSpin(controls);
    let scaleLimits = new ScaleLimits(controls);

    Q3.objectRotationControlAddons = {
        autoSpin,
        scaleLimits,
        disableFlag,
    };
}

export default init;
